/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";

const VerifyInput = ({ length = 5, onChange }) => {
  const handleKeyUp = (e) => {
    const target = e.target;
    if (!target.value.match(/^\d+$/)) return;
    onChange({ [target.name]: target.value });
    const maxLength = parseInt(target.attributes["maxlength"].value, 10);
    const myLength = target.value.length;
    if (myLength >= maxLength) {
      var next = target;
      while ((next = next.nextElementSibling)) {
        if (next == null) break;
        if (next.tagName.toLowerCase() === "input") {
          next.focus();
          break;
        }
      }
    }
  };
  const digits = [];
  for (let i = 0; i < length; i++) {
    digits.push(<input className="vrf-inp" name={`digit${i}`} type="text" maxLength="1" key={i} />);
  }
  return (
    <div className="vrf-div" onKeyUp={handleKeyUp}>
      {digits}
    </div>
  );
};

export default VerifyInput;
